import React from "react";
import { Link } from "react-router-dom";
import { useT } from "@/i18n";
import { LangToggle } from "@/components/LangToggle";
import { Logo } from "@/components/Logo";

export default function Privacy() {
  const { t } = useT();
  return (
    <div className="min-h-screen bg-[#0D0E11] py-10 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <Link to="/" className="inline-block"><Logo className="h-8" /></Link>
          <LangToggle />
        </div>
        <h1 className="text-3xl font-extrabold text-white mb-6">{t("Politica de confidențialitate")}</h1>
        <div className="space-y-4 text-slate-300 text-sm leading-relaxed">
          <p>{t("Operatorul datelor cu caracter personal este")} <b className="text-white">GLOW SENSE S.R.L.</b>,
            {t("CUI RO35285172, Nr. Reg. Com. J2019001504231, cu sediul social în Șos. Erou Iancu Nicolae nr. 107C, Parter, Camera 2, Voluntari, Ilfov.")}</p>
          <p>{t("Prin crearea unui cont în KLUS AI Lighting Studio, îți exprimi consimțământul pentru prelucrarea datelor tale cu caracter personal (nume, email, telefon, județ, tip client) în scopul contactării comerciale și al statisticilor interne, conform Regulamentului (UE) 2016/679 (GDPR).")}</p>
          <p>{t("Fotografiile încărcate și randările generate sunt stocate securizat și sunt șterse la 90 de zile de la închiderea proiectului, dacă nu există o cerință legală contrară. Proiectele inactive se păstrează 12 luni.")}</p>
          <p>{t("Consimțământul de marketing este opțional și poate fi retras oricând. Ai dreptul de acces, rectificare, ștergere, restricționare, portabilitate și opoziție. Pentru exercitarea acestor drepturi ne poți contacta la adresa de email a operatorului.")}</p>
          <p>{t("Rezultatele generate de AI au caracter orientativ și necesită validare tehnică finală de către un specialist KLUS.")}</p>
        </div>
        <Link to="/register" className="inline-block mt-8 text-primary hover:underline">← {t("Înapoi la înregistrare")}</Link>
      </div>
    </div>
  );
}
